"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fluxible_router_1 = require("fluxible-router");
class CategoriesWidgetProps {
}
class CategoriesWidget extends React.Component {
    render() {
        return (React.createElement("div", { className: 'well' },
            React.createElement("h4", null, "Blog Categories"),
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-lg-6' },
                    React.createElement("ul", { className: 'list-unstyled' }, this.props.data.queryData.map((category) => {
                        return (React.createElement("li", { key: category.key },
                            React.createElement(fluxible_router_1.NavLink, { preserveScrollPosition: true, href: '/blog?category=' + category.key }, category.name)));
                    }))))));
    }
}
exports.default = CategoriesWidget;
